// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".call-to-action{background-size:cover;background-position:50%;background-repeat:no-repeat}.call-to-action__description a{color:#fff;text-decoration:underline}@media (max-width:575px){.call-to-action__button{text-align:center}}@media (max-width:575px){.call-to-action__button .btn{width:100%}}", ""]);
// Exports
module.exports = exports;
